var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9381 3.65247C58.0293 2.68212 57.3166 1.82159 56.3462 1.73042L40.5335 0.244677C39.5632 0.153504 38.7027 0.866216 38.6115 1.83656C38.5203 2.80691 39.233 3.66744 40.2034 3.75861L54.2591 5.07927L52.9385 19.135C52.8473 20.1054 53.56 20.9659 54.5303 21.0571C55.5007 21.1482 56.3612 20.4355 56.4524 19.4652L57.9381 3.65247ZM2.94302 49.8718L57.3068 4.84648L55.0555 2.12829L0.69175 47.1536L2.94302 49.8718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutArrow);
export default __webpack_public_path__ + "static/media/about-arrow.d2ab1e5f28f34633c3d57abf2a34d179.svg";
export { ForwardRef as ReactComponent };